const initialState = {
	isLoading: false,
	data: null,
	error: null,
	formData: {
		url: '',
		maxPages: 10,
		includeAI: true
	}
};

export default (state = initialState, action) => {
	switch (action.type) {
		case "[WEBCRAWL] SET_IS_LOADING":
			return {
				...state,
				isLoading: action.isLoading
			};
		
		case "[WEBCRAWL] SET_DATA":
			return {
				...state,
				data: action.data,
				error: null
			};
		
		case "[WEBCRAWL] SET_ERROR":
			return {
				...state,
				error: action.error,
				data: null
			};
		
		case "[WEBCRAWL] SET_FORM_DATA":
			return {
				...state,
				formData: {
					...state.formData,
					...action.formData
				}
			};
		
		case "[WEBCRAWL] RESET_STATE":
			return {
				...initialState
			};
		
		default:
			return state;
	}
};
